<a class="text-center" (click)="onWhatsAppButtonClick()">
  <button mat-button class="Btn BtnPadrao">
    <!--<span class="material-icons align-middle"> whatsapp </span>-->
    {{this.textWhatsApp}}
  </button>
</a>